import { Box, Menu, MenuButton, MenuItem, MenuList, Tooltip } from '@chakra-ui/react';
import { Braces, Send } from 'lucide-react';
import { useState } from 'react';

import { lang } from '@lang';
import { ReportBugModal } from '@components';
import { useDownloadBlueprintFeature, useDownloadDiagnosticsFeature, useImportBlueprintFeature } from '@features';

export const BlueprintFileMenu = (): React.ReactElement => {
	const downloadBlueprintFeature = useDownloadBlueprintFeature();
	const downloadDiagnosticsFeature = useDownloadDiagnosticsFeature();
	const importBlueprintFeature = useImportBlueprintFeature();

	const [isReportBugOpen, setIsReportBugOpen] = useState<boolean>(false);

	return (
		<>
			<Menu>
				<Tooltip hasArrow
					label={lang.customer.tooltip.blueprintFileMenu}
					aria-label={lang.customer.tooltip.blueprintFileMenu}
					openDelay={250}
					arrowSize={15}
				>
					<MenuButton as={Box}
						padding={'2px'}
						fontSize={'26px'}
						cursor={'pointer'}
						height={'30px'}
						display={'inline-flex'}
						alignItems={'center'}
						_active={{ transform: 'scale(0.98)' }}
					>
						<Braces />
					</MenuButton>
				</Tooltip>
				<MenuList>
					<Tooltip display={downloadBlueprintFeature.disabled ? 'inherit' : 'none'} label={downloadBlueprintFeature.tooltip}>
						<MenuItem
							isDisabled={downloadBlueprintFeature.disabled}
							icon={downloadBlueprintFeature.icon()}
							onClick={downloadBlueprintFeature.handler}
						>
							{downloadBlueprintFeature.label}
						</MenuItem>
					</Tooltip>
					<Tooltip display={importBlueprintFeature.disabled ? 'inherit' : 'none'} label={importBlueprintFeature.tooltip}>
						<MenuItem
							isDisabled={importBlueprintFeature.disabled}
							icon={importBlueprintFeature.icon()}
							onClick={importBlueprintFeature.handler}
						>
							{importBlueprintFeature.label}
						</MenuItem>
					</Tooltip>
					<Tooltip display={downloadDiagnosticsFeature.disabled ? 'inherit' : 'none'} label={downloadDiagnosticsFeature.tooltip}>
						<MenuItem
							isDisabled={downloadDiagnosticsFeature.disabled}
							icon={downloadDiagnosticsFeature.icon()}
							onClick={downloadDiagnosticsFeature.handler}
						>
							{downloadDiagnosticsFeature.label}
						</MenuItem>
					</Tooltip>
					<Tooltip label={lang.customer.tooltip.reportBug}>
						<MenuItem
							icon={<Send />}
							onClick={() => setIsReportBugOpen(true)}
						>
							{lang.customer.label.reportBug}
						</MenuItem>
					</Tooltip>
				</MenuList>
			</Menu>
			<ReportBugModal isOpen={isReportBugOpen} onClose={() => setIsReportBugOpen(false)} />
		</>
	);
};
